import S from 's-js';

export interface SynchronousSet<T> {
    () : Set<T>
    (items : Set<T>) : Set<T>
    add(item : T) : SynchronousSet<T>
    clear() : SynchronousSet<T>
    delete(item : T) : boolean
}

export const SynchronousSet = <T>(init? : Iterable<T>) => {
    let items = new Set<T>(init as T[]), // ts types don't appear to have the iterable signature on Set yet
        adds = new Set<T>(),
        deletes = new Set<T>(),
        clear = false,
        reset : Set<T> | null = null,
        changed = S.data(true),
        update = S.root(() => S.on(changed, () => {
            var item : T;
            if (reset) items = reset;
            else if (clear) items.clear();
            else for (item of Array.from(deletes)) items.delete(item);
            for (item of Array.from(adds)) items.add(item);
            clear = false;
            reset = null;
            deletes.clear();
            adds.clear();
        })),
        set = ((_reset? : Set<T>) => _reset ? (changed(true), reset = _reset) : (update(), items)) as SynchronousSet<T>;

    set.add = item => (adds.add(item), changed(true), set);
    set.delete = item => (deletes.add(item), changed(true), items.has(item));
    set.clear = () => (clear = true, changed(true), set);

    return set;
}


// WEBPACK FOOTER //
// ./lib/SynchronousSet.ts